import { createSelector, createStructuredSelector } from 'reselect';
import { flow, get } from 'lodash/fp';
import getScriptFromHtml from 'helpers/getScriptFromHtml';
import { parseJSON } from 'helpers/safetyJSON';
import { STORE_KEY } from '../duck';

const getScript = (content = '') =>
  content ? getScriptFromHtml(content) : null;

const getDsbMainWidgetProps = createSelector(
  get([STORE_KEY, 'dsbWidget']),
  get([STORE_KEY, 'dsbBookingWidget']),
  ({ isLoaded, result }, { result: bookingResult }) => ({
    isLoaded,
    dsbHtml: get(['body_content'], result),
    dsbScript: getScript(get(['footer_content'], result)),
    dsbBookingContent: flow(get(['body-content']), parseJSON)(bookingResult),
  }),
);

export default createStructuredSelector({
  dsbMainWidgetProps: getDsbMainWidgetProps,
});
